import './ListInfoCardComponent.scss';

interface ListInfoCardComponentProps {
    prefixIcon?: any;
    value: string | number;
    description?: any;
    action?: React.ReactNode;
    backgroundColor?: any;
    imageUrl?: any;
    subDescription?: any;
}

const ListInfoCardComponent = (props: ListInfoCardComponentProps) => {
    const {value, description, imageUrl, subDescription, prefixIcon, backgroundColor, action} = props;
    return (
        <div className="list-info-card" style={{
            backgroundColor: backgroundColor ? backgroundColor : "#F5F7F8"
        }}>
            {
                imageUrl ? <div className="image-container">
                    <div className={'d-flex'}>
                        <img src={imageUrl} alt={'provider'} className={'image'}/>

                        <div className="details">
                            <div className="value">{prefixIcon ? <span>{prefixIcon}{value} </span> :
                                <span>{value}</span>}</div>
                            <div className="info">{description}</div>
                            <div className="sub-info">{subDescription}</div>
                        </div>
                    </div>
                    <div className="action">{action}</div>
                </div> : <>
                    <div className="details">
                        <div className="value">{prefixIcon ? <span>{prefixIcon}{value} </span> :
                            <span>{value}</span>}</div>
                        <div className="info">{description}</div>
                    </div>
                    <div className="action">{action}</div>
                </>
            }
        </div>

    )
        ;
}
export default ListInfoCardComponent;
